export const STORAGE_KEY = 'appLocale'

export const OVERRIDE_NAMESPACES = ['bottimmo', 'smg', 'remax', 'falc', 'master']

/** Matches paths from import.meta.glob in translations.js: ../locales/{lang}/{namespace}.json */
export const PATH_REGEX = /\.\.\/locales\/([^/]+)\/([^/]+)\.json$/
